// extracted by mini-css-extract-plugin
export default {"seedScene":"style_seedScene__Zsffd","reviewScene":"style_reviewScene__2ItaR"};